import React, { useState, useEffect, useRef } from 'react';
import '../../assets/Styles/DispatchCSS/sidebarCSS.css';
import {Icon} from '@iconify/react';
import { useSelector } from "react-redux";
import ModuleSecurity from '../../utils/helpers/ModuleSecurity';
import APICom from "../../utils/helpers/APICom.js";
import { useDispatch } from 'react-redux';
import CommonFunctions from '../../utils/helpers/CommonFunctions';
import { SetCombineData } from '../../features/common/combinedataSlice';

const MenuSideBar = (props = {}) => {
    const {GlobalASCSData} = useSelector((store) => store.combinedata);
    const xCancelSourceForGrid = useRef(null);
    const dispatch = useDispatch();

    const [InputHTML, setInputHTML] = useState([]);
    const [SignOut, setSignOutHTML] = useState([]);
    const [listofTripActionsHTML, setListofTripActionsHTML] = useState([]);
    const [listofCallCenterActionsHTML, setListofCallCenterActionsHTML] = useState([]);
    const [listofDriverActionsHTML, setListofDriverActionsHTML] = useState([]);
    const [listofBrokerActionsHTML, setListofBrokerActionsHTML] = useState([]);
    const [listofRouteActionsHTML, setListofRouteActionsHTML] = useState([]);
    const [listofMTDiagnosticHTML, setListofMTDiagnosticHTML] = useState([]);
    const [menuResizeGroupBtnHTML, setMenuResizeGroupBtnHTML] = useState(<Icon icon={'bx:collapse-alt'} style={{color:"orange", cursor:"pointer"}}/>);
    const [tripActionsArrowHTML, setTripActionsArrowHTML] = useState(<Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>);
    const [callCenterActionsArrowHTML, setCallCenterActionsArrowHTML] = useState(<Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>);
    const [driverActionsArrowHTML, setDriverActionsArrowHTML] = useState(<Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>);
    const [brokerActionsArrowHTML, setBrokerActionsArrowHTML] = useState(<Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>);
    const [routeActionsArrowHTML, setRouteActionsArrowHTML] = useState(<Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>);
    const [mtDiagnosticArrowHTML, setMTDiagnosticArrowHTML] = useState(<Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>);
    const [menuReloadCombinedDataCacheBtnHTML, setMenuReloadCombinedDataCacheBtnHTML] = useState(<Icon icon={'streamline:arrow-reload-horizontal-2-solid'} style={{color:"green", cursor:"pointer"}}/>);
    const isReloadCombinedDataCachedAPICallInProgress = useRef(false);

    const tripActionsRef = useRef(null);
    const callCenterActionsRef = useRef(null);
    const driverActionsRef = useRef(null);
    const brokerActionsRef = useRef(null);
    const routeActionsRef = useRef(null);
    const mtDiagnosticRef = useRef(null);

    const sidebarWrapper = useRef(null);
    const reSizeBtnIconRef = useRef(null);
    const menuTracker = useRef(false);
    const { isLoggedIn, loginData } = useSelector((store) => store.login);

    const handleClosedSidebar = ()=>{
        try{
            if(menuTracker.current)
            {
                // console.log("closed");
                props.navbarTracker.classList.remove('navBarStyle');
                let gridContainer = document.getElementById(props.options.GridName+"_container");
                let mapContainer = document.getElementById(props.options.GridName +'_mapContainer');
                let clusterContainer = document.getElementById("clusterTableGrid_container");
                if(document.getElementById(props.options.GridName+'_mapViewBtn').textContent.toUpperCase() === "MAP")
                {
                    gridContainer.classList.remove('gridClosedMapStyle');
                }
                else
                {
                    gridContainer.classList.remove('gridOpenMapStyle');
                    mapContainer.classList.remove('mapOpenStyle');
                    clusterContainer.classList.remove('mapOpenStyle');
                }
            }
        }
        catch(err){console.log(err);}
        
    };

    const handleSidebarToggle = () =>{
        props.setMenuSidebarToggle(prevCheck => !prevCheck);
        menuTracker.current = true;
        props.SetSidebarStatus(false);
        handleClosedSidebar(); 
    }

    const handleCollapseSideBar = (e)=>{
        try{
            
            let btnHTML = "";
            let arrowHTML = "";
            if(reSizeBtnIconRef.current.title.toLowerCase().includes("collapse"))
            {
                reSizeBtnIconRef.current.title = "Expand Sidebar Groups";
                btnHTML = function(){
                    return(
                        <Icon icon={'bx:expand-alt'} style={{color:"orange", cursor:"pointer"}}/>
                    );
                };
                arrowHTML = function(){
                    return(
                        <Icon icon={'bx:chevron-up'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>
                    );
                };
                tripActionsRef.current.classList = "nav-list my-0 collapse";
                callCenterActionsRef.current.classList = "nav-list my-0 collapse";
                driverActionsRef.current.classList = "nav-list my-0 collapse";
                brokerActionsRef.current.classList = "nav-list my-0 collapse";
                routeActionsRef.current.classList = "nav-list my-0 collapse";
                mtDiagnosticRef.current.classList = "nav-list my-0 collapse";
                
            }
            else
            {
                reSizeBtnIconRef.current.title = "Collapse Sidebar Groups";
                btnHTML = function(){
                    return(
                        <Icon icon={'bx:collapse-alt'} style={{color:"orange", cursor:"pointer"}}/>
                    );
                };
                arrowHTML = function(){
                    return(
                        <Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>
                    );
                };
                tripActionsRef.current.classList = "nav-list my-0 expand";
                callCenterActionsRef.current.classList = "nav-list my-0 expand";
                driverActionsRef.current.classList = "nav-list my-0 expand";
                brokerActionsRef.current.classList = "nav-list my-0 expand";
                routeActionsRef.current.classList = "nav-list my-0 expand";
                mtDiagnosticRef.current.classList = "nav-list my-0 expand";
            }
            setMenuResizeGroupBtnHTML(btnHTML);
            setTripActionsArrowHTML(arrowHTML);
            setCallCenterActionsArrowHTML(arrowHTML);
            setDriverActionsArrowHTML(arrowHTML);
            setBrokerActionsArrowHTML(arrowHTML);
            setRouteActionsArrowHTML(arrowHTML);
            setMTDiagnosticArrowHTML(arrowHTML)
            
        }
        catch(err){console.log(err);}
    };

    const getCombinedDataAPIURLFromSettings = () => {
        let combinedDataAPIURL = GlobalASCSData.find(item => item.SubTitle === "MRMS2CombinedAPIURL").value;
        try {
            if(combinedDataAPIURL != undefined && combinedDataAPIURL != null && combinedDataAPIURL != ""){
                 let lastCharacter = [(combinedDataAPIURL.length - 1)];
                 if(lastCharacter != undefined){
                     if(lastCharacter == '/'){
                         combinedDataAPIURL += "CombinedData/GenerateCombinedData";
                     }
                     else{
                         combinedDataAPIURL += "/CombinedData/GenerateCombinedData";
                     }
                 }
            }
         } catch (error) {
             console.log(error);
             return combinedDataAPIURL;
         }
         return combinedDataAPIURL;
    }
    
    const setReloadCombinedDataAPIIconColor = (response = "default") => {
        let iconColor = <Icon icon={'streamline:arrow-reload-horizontal-2-solid'} style={{color:"green", cursor:"pointer"}}/>
        try {

            if(response == false){
                iconColor = function(){
                    return(
                        <Icon icon={'streamline:arrow-reload-horizontal-2-solid'} style={{color:"darkgrey", cursor:"pointer"}}/>
                    );
                };
                setMenuReloadCombinedDataCacheBtnHTML(iconColor);
            }
            else if (response == true){
                setMenuReloadCombinedDataCacheBtnHTML(iconColor);
            }
            else if (response == "NoURL"){
                iconColor = <Icon icon={'streamline:arrow-reload-horizontal-2-solid'} style={{color:"darkred", cursor:"pointer"}}/>
                setMenuReloadCombinedDataCacheBtnHTML(iconColor);
            }
            else{
                iconColor = <Icon icon={'streamline:arrow-reload-horizontal-2-solid'} style={{color:"darkgrey", cursor:"pointer"}}/>
                setMenuReloadCombinedDataCacheBtnHTML(iconColor);
            }
        } catch (error) {
            iconColor =  <Icon icon={'streamline:arrow-reload-horizontal-2-solid'} style={{color:"darkred", cursor:"pointer"}}/>
            setMenuReloadCombinedDataCacheBtnHTML(iconColor);
        }
    }

    const handleReloadCombinedDataAPI = async(e) => {
        try {
            if(isReloadCombinedDataCachedAPICallInProgress.current == true){
                return;
            }
            setReloadCombinedDataAPIIconColor("default");
            let combinedDataAPIURL = getCombinedDataAPIURLFromSettings();
            if(combinedDataAPIURL != undefined && combinedDataAPIURL != null && combinedDataAPIURL != ""){
                xCancelSourceForGrid.current = APICom.GenerateSource();
                isReloadCombinedDataCachedAPICallInProgress.current = true;
                let response = await APICom.fetchData(combinedDataAPIURL,"", "get", 
                  {'Content-Type': 'application/json',
                  'Access-Control-Allow-Origin': '*',
                  'Access-Control-Allow-Headers': '*',
                  'mode': 'no-cors'}, "", xCancelSourceForGrid.current
                );
                if(response != undefined && response != null){
                    isReloadCombinedDataCachedAPICallInProgress.current = false;
                    if(response.data == true){
                        setReloadCombinedDataAPIIconColor(response.data);
                        const responseCombinedData = await CommonFunctions.PopulateCombineData();
                        dispatch(SetCombineData({data: responseCombinedData["FamilyData"], name:"FamilyData"}));
                        dispatch(SetCombineData({data: responseCombinedData["AffiliateData"], name:"AffiliateData"}));
                        dispatch(SetCombineData({data: responseCombinedData["BrokerServingAffiliatesData"], name:"BrokerServingAffiliatesData"}));
                        dispatch(SetCombineData({data: responseCombinedData["FundingSourceData"], name:"FundingSourceData"}));
                        dispatch(SetCombineData({data: responseCombinedData["ASCSSettingData"], name:"ASCSSettingData"}));
                        dispatch(SetCombineData({data: responseCombinedData["CancelReasonData"], name:"CancelReasonData"}));
                        dispatch(SetCombineData({data: responseCombinedData["NoShowReasonData"], name:"NoShowReasonData"}));
                        dispatch(SetCombineData({data: responseCombinedData["DispatchDriverData"], name:"DispatchDriverData"}));
                        dispatch(SetCombineData({data: responseCombinedData["DispatchVehicleData"], name:"DispatchVehicleData"}));
                        dispatch(SetCombineData({data: responseCombinedData["BrokerCancelReasonData"], name:"BrokerCancelReasonData"}));
                        dispatch(SetCombineData({data: responseCombinedData["VehicleInfoData"], name:"VehicleInfoData"}));
                        dispatch(SetCombineData({data: responseCombinedData["AttributeData"].Table, name:"AttributeData"}));
                        dispatch(SetCombineData({data: responseCombinedData["GlobalASCSData"], name:"GlobalASCSData"}));
                        dispatch(SetCombineData({data: responseCombinedData["ZoneVerticesData"], name:"ZoneVerticesData"}));
                        dispatch(SetCombineData({data: responseCombinedData["VirtualStopsData"], name:"VirtualStopsData"}));
                        dispatch(SetCombineData({data: responseCombinedData["ClassOfServiceData"], name:"ClassOfServiceData"}));
                        dispatch(SetCombineData({data: responseCombinedData["PaymentTypesData"], name:"PaymentTypesData"}));
                        dispatch(SetCombineData({data: responseCombinedData["RCZZoneVerticesData"], name:"RCZZoneVerticesData"}));
                    }
                    else
                    {
                        setReloadCombinedDataAPIIconColor(false);
                    }
                }
            }
            else{
                setReloadCombinedDataAPIIconColor("NoURL");
            }
        } catch (error) {
            console.log(error);
            isReloadCombinedDataCachedAPICallInProgress.current = false;
        }
    }

    const handleReSizeMenu = (type)=>{
        try{
            let arrowHTML = "";
            if(type === "callcenter")
            {
                if(callCenterActionsRef.current.classList.contains("collapse"))
                {   
                    callCenterActionsRef.current.classList = "nav-list my-0 expand";
                    arrowHTML = function(){
                        return(
                            <Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>
                        );
                    };
                }
                else
                {
                    callCenterActionsRef.current.classList = "nav-list my-0 collapse";
                    arrowHTML = function(){
                        return(
                            <Icon icon={'bx:chevron-up'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>
                        );
                    };
                }
                setCallCenterActionsArrowHTML(arrowHTML);
            }
            else if(type === "trip")
            {
                if(tripActionsRef.current.classList.contains("collapse"))
                {   
                    tripActionsRef.current.classList = "nav-list my-0 expand";
                    arrowHTML = function(){
                        return(
                            <Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>
                        );
                    };
                }
                else
                {
                    tripActionsRef.current.classList = "nav-list my-0 collapse";
                    arrowHTML = function(){
                        return(
                            <Icon icon={'bx:chevron-up'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>
                        );
                    };
                }
                setTripActionsArrowHTML(arrowHTML);
            }
            else if(type === "driver")
            {
                if(driverActionsRef.current.classList.contains("collapse"))
                {   
                    driverActionsRef.current.classList = "nav-list my-0 expand";
                    arrowHTML = function(){
                        return(
                            <Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>
                        );
                    };
                }
                else
                {
                    driverActionsRef.current.classList = "nav-list my-0 collapse";
                    arrowHTML = function(){
                        return(
                            <Icon icon={'bx:chevron-up'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>
                        );
                    };
                }
                setDriverActionsArrowHTML(arrowHTML);
            }
            else if(type === "broker")
            {
                if(brokerActionsRef.current.classList.contains("collapse"))
                {   
                    brokerActionsRef.current.classList = "nav-list my-0 expand";
                    arrowHTML = function(){
                        return(
                            <Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>
                        );
                    };
                }
                else
                {
                    brokerActionsRef.current.classList = "nav-list my-0 collapse";
                    arrowHTML = function(){
                        return(
                            <Icon icon={'bx:chevron-up'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>
                        );
                    };
                }
                setBrokerActionsArrowHTML(arrowHTML);
            }
            else if(type === "route")
            {
                if(routeActionsRef.current.classList.contains("collapse"))
                {   
                    routeActionsRef.current.classList = "nav-list my-0 expand";
                    arrowHTML = function(){
                        return(
                            <Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>
                        );
                    };
                }
                else
                {
                    routeActionsRef.current.classList = "nav-list my-0 collapse";
                    arrowHTML = function(){
                        return(
                            <Icon icon={'bx:chevron-up'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>
                        );
                    };
                }
                setRouteActionsArrowHTML(arrowHTML);
            }

            else if(type === "mtdiagnostic")
                {
                    if(mtDiagnosticRef.current.classList.contains("collapse"))
                    {   
                        mtDiagnosticRef.current.classList = "nav-list my-0 expand";
                        arrowHTML = function(){
                            return(
                                <Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>
                            );
                        };
                    }
                    else
                    {
                        mtDiagnosticRef.current.classList = "nav-list my-0 collapse";
                        arrowHTML = function(){
                            return(
                                <Icon icon={'bx:chevron-up'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>
                            );
                        };
                    }
                    setMTDiagnosticArrowHTML(arrowHTML);
                }
        }
        catch(err){console.log(err);}
    };
    const handleBtnFuncMapping = () => {
        try{
            if(props.btnFuncs.length !== 0)
            {
                // console.log(props.btnFuncs);
                let dynamicElements = "";
                let inputSearch = "";
                let logoutHTML = "";
                inputSearch = props.btnFuncs.map(function(item, index){
                    if(item.btnName === "input"){
                        return(
                            <li key={index} className='my-0'>
                                <input  className='bg-white h-100 rounded-0 text-center p-0 px-1 text-dark' onKeyUp={item.btnFunc} type='text' placeholder='Search...'/>
                            </li>
                        );
                    }
                });
                logoutHTML= props.btnFuncs.map(function(item, index){
                    if(item.btnName === "Sign Out")
                    {
                        return(
                            <li key={index} className='my-0'>
                                <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                    <Icon icon={'bx:'+item.icon} style={{color:"red"}}/>
                                    <span className="links_name fw-bold text-danger">{item.btnName}</span>
                                </a>
                                <span className="tooltip">{item.btnName}</span>
                            </li>
                        );
                    }
                });
                setSignOutHTML(logoutHTML);
                setInputHTML(inputSearch);
                dynamicElements = props.btnFuncs
                .filter(element =>{ 
                    if(!element.tag){
                        return true;
                    }
                    else if(ModuleSecurity.CheckModuleSecurityByTag(element.tag) === false){
                        return false;
                    }
                    else{
                        return true;
                    }
                })
                .map(function(item, index) {
                    if(item.btnName !== "input" && ["Trip Reservation", "Trip Edit"].includes(item.btnName))
                    {
                        return(
                            <li key={index} className='sidebarOptionClass mx-2 my-0' style={{fontSize:"smaller"}}>
                                <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                    <Icon icon={'bx:'+item.icon}/>
                                    <span className="links_name" style={{fontSize:"small"}}>{item.btnName}</span>
                                </a>
                                <span className="tooltip">{item.btnName}</span>
                            </li>
                        );
                    }
                    
                });

                setListofCallCenterActionsHTML(dynamicElements)

                dynamicElements = props.btnFuncs
                .filter(element =>{ 
                    if(!element.tag){
                        return true;
                    }
                    else if(ModuleSecurity.CheckModuleSecurityByTag(element.tag) === false){
                        return false;
                    }
                    else{
                        return true;
                    }
                })
                .map(function(item, index) {
                    if(item.btnName !== "input" && ["Dispatch Actions", "Agile Dispatch", "Cancel", "Activate", "Trip History", "Trip Information"].includes(item.btnName))
                    {
                        return(
                            <li key={index} className='sidebarOptionClass mx-2 my-0' style={{fontSize:"smaller"}}>
                                <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                    <Icon icon={'bx:'+item.icon}/>
                                    <span className="links_name" style={{fontSize:"small"}}>{item.btnName}</span>
                                </a>
                                <span className="tooltip">{item.btnName}</span>
                            </li>
                        );
                    }
                    
                });
                
                setListofTripActionsHTML(dynamicElements);
    
                dynamicElements = props.btnFuncs
                .filter(element =>{ 
                    if(!element.tag){
                        return true;
                    }
                    else if(ModuleSecurity.CheckModuleSecurityByTag(element.tag) === false){
                        return false;
                    }
                    else{
                        return true;
                    }
                })
                .map(function(item, index) {
                    if(item.btnName !== "input" && ["Driver Controls", "Vehicle Tracking", "Callback Counter"].includes(item.btnName))
                    {
                        return(
                            <li key={index} className='sidebarOptionClass mx-2 my-0' style={{fontSize:"smaller"}}>
                                <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                    <Icon icon={'bx:'+item.icon}/>
                                    <span className="links_name" style={{fontSize:"small"}}>{item.btnName}</span>
                                </a>
                                <span className="tooltip">{item.btnName}</span>
                            </li>
                        );
                    }
                    
                });
    
                setListofDriverActionsHTML(dynamicElements);
                
                dynamicElements = props.btnFuncs
                .filter(element =>{ 
                    if(!element.tag){
                        return true;
                    }
                    else if(ModuleSecurity.CheckModuleSecurityByTag(element.tag) === false){
                        return false;
                    }
                    else{
                        return true;
                    }
                })
                .map(function(item, index) {
                    if(item.btnName !== "input" && ["Broker Actions"].includes(item.btnName))
                    {
                        return(
                            <li key={index} className='sidebarOptionClass mx-2 my-0' style={{fontSize:"smaller"}}>
                                <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                    <Icon icon={'bx:'+item.icon}/>
                                    <span className="links_name" style={{fontSize:"small"}}>{item.btnName}</span>
                                </a>
                                <span className="tooltip">{item.btnName}</span>
                            </li>
                        );
                    }
                    
                });
    
                setListofBrokerActionsHTML(dynamicElements);
                dynamicElements = props.btnFuncs
                .filter(element =>{ 
                    if(!element.tag){
                        return true;
                    }
                    else if(ModuleSecurity.CheckModuleSecurityByTag(element.tag) === false){
                        return false;
                    }
                    else{
                        return true;
                    }
                })
                .map(function(item, index) {
                    if(item.btnName !== "input" && ["Standing Routes", "RBSProcess", "Grouping Actions", 
                        "Clustering Actions", "Route Restrictions", "Manifest Actions", ].includes(item.btnName))
                    {
                        return(
                            <li key={index} className='sidebarOptionClass mx-2 my-0 py-0' style={{fontSize:"smaller"}}>
                                <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                    <Icon icon={'bx:'+item.icon}/>
                                    <span className="links_name" style={{fontSize:"small"}}>{item.btnName}</span>
                                </a>
                                <span className="tooltip">{item.btnName}</span>
                            </li>
                        );
                    }
                    
                });
    
                setListofRouteActionsHTML(dynamicElements);

                dynamicElements = props.btnFuncs
                .filter(element =>{ 
                    if(!element.tag){
                        return true;
                    }
                    else if(ModuleSecurity.CheckModuleSecurityByTag(element.tag) === false){
                        return false;
                    }
                    else{
                        return true;
                    }
                })
                .map(function(item, index) {
                    if(item.btnName !== "input" && ["MT Diagnostic"].includes(item.btnName))
                    {
                        return(
                            <li key={index} className='sidebarOptionClass mx-2 my-0 py-0' style={{fontSize:"smaller"}}>
                                <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                    <Icon icon={'bx:'+item.icon}/>
                                    <span className="links_name" style={{fontSize:"small"}}>{item.btnName}</span>
                                </a>
                                <span className="tooltip">{item.btnName}</span>
                            </li>
                        );
                    }
                    
                });
    
                setListofMTDiagnosticHTML(dynamicElements);
            }
            else
            {
                setListofTripActionsHTML("");
                setListofCallCenterActionsHTML("");
                setListofDriverActionsHTML("");
                setListofBrokerActionsHTML("");
                setListofRouteActionsHTML("");
                setListofMTDiagnosticHTML("");
            }
        }
        catch(err){console.log(err);}
    };

    useEffect(()=> {
        try{
            
            handleBtnFuncMapping();
            // function handleClickOutsideSidebar(event){
            //     // if (sidebarWrapper.current && !sidebarWrapper.current.contains(event.target))
            //     // {
            //     //     handleSidebarToggle();
            //     // }
            // };
    
            // document.addEventListener("mousedown", handleClickOutsideSidebar);
            // return() => {
            //     document.removeEventListener("mousedown", handleClickOutsideSidebar);
            // };
        }
        catch(err){console.log(err);}
        
    },[sidebarWrapper]);

    useEffect(()=> { //fix to btn func not being updated with open menu when affiliate changes
        try{
            handleBtnFuncMapping();
        }
        catch(err){console.log(err);}
    }, [JSON.stringify(props.btnFuncs)]);
    
    return (
        
        <nav ref={sidebarWrapper} className="sidebar open prevent-select" id="sidebar">
            <div className="logo-details">
                <div className="logo_name">Menu</div>
                <span ref={reSizeBtnIconRef} className='m-1 rounded' title={"Collapse Sidebar Groups"} onClick={handleCollapseSideBar}>
                    {menuResizeGroupBtnHTML}
                </span>
                <span className='m-1' title={"Reload Cached Data"} onClick={handleReloadCombinedDataAPI}>
                    {menuReloadCombinedDataCacheBtnHTML}
                </span>
                <Icon icon='bx:menu-alt-right' onClick={handleSidebarToggle} style={{color:"gray"}} id="btnClose"/>
            </div>
            <div className="text-light w-100 border border-light mt-2"  ><p className='overflow-hidden text-nowrap font-weight-light text-center small px-1 my-1' style={{textOverflow:"ellipsis"}} title={loginData.vUserName}>User: {loginData.vUserName}</p></div>
            <ul className="nav-list my-0 mt-1">
                {InputHTML}
            </ul>
            <ul className="nav-list my-0 overflow-auto mt-1" style={{maxHeight:"620px"}} id="sidebarList">
                <ul className="nav-list" aria-expanded={false} id="callcenterActionsList">
                    <li className='my-0 d-flex' style={{cursor:"pointer"}} onClick={()=>{handleReSizeMenu("callcenter")}}>
                        <a title={"Call Center Actions List"}>
                            <Icon icon={'bx:support'} style={{color:"orange"}}/>
                            <span className="links_name fw-bold">{"Call Center"}</span>
                            
                        </a>
                        {callCenterActionsArrowHTML}
                        <span className="tooltip">{"Call Center"}</span>
                    </li>
                    <ul className="nav-list my-0" ref={callCenterActionsRef}>
                        {listofCallCenterActionsHTML}
                    </ul>
                </ul>
                <ul className="nav-list my-0" aria-expanded={false} id="tripActionsList">
                    <li className='my-0 d-flex' style={{cursor:"pointer"}} onClick={()=>{handleReSizeMenu("trip")}}>
                        <a title={"Trip Actions List"}>
                            <Icon icon={'bx:desktop'} style={{color:"orange"}}/>
                            <span className="links_name fw-bold">{"Trip Actions"}</span>
                            
                        </a>
                        {tripActionsArrowHTML}
                        <span className="tooltip">{"Trip Actions"}</span>
                    </li>
                    <ul className="nav-list my-0" ref={tripActionsRef}>
                        {listofTripActionsHTML}
                    </ul>
                </ul>
                <ul className="nav-list my-0" id="driverActionsList">
                    <li className='my-0 d-flex' style={{cursor:"pointer"}} onClick={()=>{handleReSizeMenu("driver")}}>
                        <a title={"Driver Actions List"}>
                            <Icon icon={'bx:taxi'} style={{color:"orange"}}/>
                            <span className="links_name fw-bold">{"Driver Actions"}</span>
                            
                        </a>
                        {driverActionsArrowHTML}
                        <span className="tooltip">{"Driver Actions"}</span>
                    </li>
                    <ul className="nav-list my-0" ref={driverActionsRef}>
                        {listofDriverActionsHTML}
                    </ul>
                </ul>
                <ul className="nav-list my-0" id="brokerActionsList">
                    <li className='my-0 d-flex' style={{cursor:"pointer"}} onClick={()=>{handleReSizeMenu("broker")}}>
                        <a title={"Broker Actions List"}>
                            <Icon icon={'bx:group'} style={{color:"orange"}}/>
                            <span className="links_name fw-bold">{"Broker Actions"}</span>
                            
                        </a>
                        {brokerActionsArrowHTML}
                        <span className="tooltip">{"Broker Actions"}</span>
                    </li>
                    <ul className="nav-list my-0" ref={brokerActionsRef}>
                        {listofBrokerActionsHTML}
                    </ul>
                </ul>
                <ul className="nav-list my-0" id="routeActionsList">
                    <li className='my-0 d-flex' style={{cursor:"pointer"}} onClick={()=>{handleReSizeMenu("route")}}>
                        <a title={"Route Actions List"}>
                            <Icon icon={'bx:trip'} style={{color:"orange"}}/>
                            <span className="links_name fw-bold">{"Route Actions"}</span>
                            
                        </a>
                        {routeActionsArrowHTML}
                        <span className="tooltip">{"Route Actions"}</span>
                    </li>
                    <ul className="nav-list my-0" ref={routeActionsRef}>
                        {listofRouteActionsHTML}
                    </ul>
                </ul>
                <ul className="nav-list my-0" id="mTDiagnosticList">
                    <li className='my-0 d-flex' style={{cursor:"pointer"}} onClick={()=>{handleReSizeMenu("mtdiagnostic")}}>
                        <a title={"Microtransit Diagnostic List"}>
                            <Icon icon={'bx:file-find'} style={{color:"orange"}}/>
                            <span className="links_name fw-bold">{"MT Diagnostic"}</span>
                            
                        </a>
                        {mtDiagnosticArrowHTML}
                        <span className="tooltip">{"MicroTransit Diagnostic"}</span>
                    </li>
                    <ul className="nav-list my-0" ref={mtDiagnosticRef}>
                        {listofMTDiagnosticHTML}
                    </ul>
                </ul>
            </ul>
            <ul className="nav-list my-0">
                {SignOut}
            </ul>
        </nav>
    );
};

export default MenuSideBar;